import TimestampAndActor from './TimestampAndActor';

export default TimestampAndActor;
